/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { Box } from "@mui/material";

import { BiometricDevicesList } from "./BiometricDevicesList";
import { useBiometricDevices } from "../../../../../hooks/query/useBiometricDevices";

// eslint-disable-next-line import/prefer-default-export
export function BiometricDeviceSettings(): React.ReactNode {
  const { data: devices = [], isLoading } = useBiometricDevices();

  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Box sx={{ flex: 1, overflow: "hidden" }}>
        <BiometricDevicesList devices={devices} isLoading={isLoading} />
      </Box>
    </Box>
  );
}
